import React, { useCallback, useRef, useState } from "react";

import { Input as AntInput, InputRef } from "antd";
import { RuleObject } from "antd/es/form";

import { parseInputRules } from "utils";

import { Form, Icon } from "components";

type InputSearchProps = {
  className?: string;
  disabled?: boolean;
  initialValue?: string;
  label?: string;
  message?: string;
  name?: string;
  rules?: RuleObject[];
  style?: React.CSSProperties;
  value?: string;
  onBlur?: (...args: unknown[]) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPressEnter?: () => void;
  dataTestId?: string;
  autoFocus?: boolean;
  isSmallVariant?: boolean;
};

export const InputSearch = ({
  className = "",
  disabled,
  initialValue,
  label,
  message,
  name,
  rules,
  style,
  value,
  onBlur = () => {},
  onChange = () => {},
  onPressEnter = () => {},
  dataTestId = "",
  autoFocus,
  isSmallVariant = false,
}: InputSearchProps) => {
  const inputElement = useRef<InputRef>(null);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);

  const handleBlur = (...args: unknown[]) => {
    setHasBeenFocused(false);
    onBlur(...args);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
  };

  const handlePlaceholder = useCallback((): string => (hasBeenFocused || value ? "" : label) ?? "", [hasBeenFocused, value, label]);

  return (
    <Form.Item
      className={`input-search ${hasBeenFocused && "active"} ${isSmallVariant && "small"} ${className}`}
      colon={false}
      name={name}
      rules={parseInputRules(rules, message)}
      initialValue={initialValue || undefined}
      style={style}
    >
      <AntInput
        allowClear
        prefix={<Icon iconName="tabler/search" />}
        ref={inputElement}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={() => setHasBeenFocused(true)}
        onPressEnter={onPressEnter}
        disabled={disabled}
        value={value}
        data-testid={dataTestId}
        autoFocus={autoFocus}
        placeholder={handlePlaceholder()}
      />
    </Form.Item>
  );
};
